// @ts-ignore
import React from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { wacToken } from "@/libraries/design/foundations";

import * as messages from "../messages.ts";

import { PriceAltContainer } from "./price-alt-container.tsx";

export interface MonthlyEnterpriseMessageProps {
    switchToAnnual: () => void;
}

export const MonthlyEnterpriseMessage = (
    props: MonthlyEnterpriseMessageProps
) => {
    const { switchToAnnual } = props;
    const intl = useIntl();
    return (
        <PriceAltContainer>
            <button
                css={buttonCss}
                type="button"
                onClick={switchToAnnual}
                tabIndex={0}
                data-event-component="linkButton"
                data-event="clicked"
            >
                {intl.formatMessage(messages.billedAnnually)}
            </button>
            &nbsp;
            {intl.formatMessage(messages.switchToAnnualToViewEnterprise)}
        </PriceAltContainer>
    );
};

const buttonCss = css({
    "background": "transparent",
    "border": 0,
    "cursor": "pointer",
    "color": wacToken("color.primary.blue"),
    "fontFamily": "inherit",
    "fontSize": "inherit",
    "lineHeight": 0,
    "padding": 0,
    "textOverflow": "ellipsis",
    "textDecoration": "underline",
    "whiteSpace": "nowrap",
    ":hover": {
        color: wacToken("color.extended.blue800")
    }
});
